import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Link } from 'core/routing';
import Button from 'components/Button';

export const Main = styled.div`
  width: 100%;
  margin: 40px 0 0;
  border-bottom: ${props =>
    props.noBorder ? 'none' : '1px solid rgba(0, 0, 0, 0.075)'};
  position: relative;
`;

export const CategoryWrapper = styled.div`
  margin-bottom: 20px;
`;

export const BackLink = styled(Link)`
  color: ${props => props.theme.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const Name = styled.h2`
  font-size: 1.375em;
  display: inline-block;
  vertical-align: middle;
  color: ${props =>
    props.light ? props.theme.color.wfGrey500 : props.theme.color.wfGrey900};
  ${media.s`
    font-size: 1.45em;
  `};
  &:hover {
    text-decoration: ${props => (props.isLink ? 'underline' : 'none')};
    text-decoration-color: ${props => props.color};
  }
`;

export const Color = styled.span`
  color: ${props => props.color};
`;

export const Description = styled.div`
  margin-bottom: ${props => props.theme.spacing.default};
  width: 680px;
  line-height: 1.65;
  color: #333;
  ${media.s`
    width: calc(100% - 10px);
    font-size: 0.9em;
  `};
`;

export const ButtonStyled = styled(Button)`
  position: absolute;
  bottom: ${props => props.theme.spacing.default};
  right: 0;
  ${media.s`
    position: static;
    margin-bottom: ${props => props.theme.spacing.default};
  `}
`;
